<!--
    Displays a view inside the renderer component.
-->

<template>
    <div ref="container" class="cz2__renderer__content">
        <camera-view :controller="controller" :view="selectedView" :onlyController="onlyController" :noPoster="disablePoster" />
    </div>
</template>

<script>
    import CameraView from './Three/CameraView.vue';

    export default {
        props: {
            view: {
                type: String,
                default: '',
            },

            controller: {
                type: Object,
                default: null,
            },

            onlyController: {
                type: Object,
                default: null,
            },
        },

        components: {
            CameraView,
        },

        computed: {
            globalOptions() {
                return this.$store.state.options;
            },

            selectedView() {
                if (this.controller && this.controller.blueprint && this.controller.state) {
                    const foundView = this.controller.blueprint.views.find((v) => v.code === this.view);

                    return foundView;
                }

                return null;
            },

            disablePoster() {
                return this.controller?.blueprint?.custom['three-poster'] === 'false';
            },
        },

        watch: {
            controller() {
                if (this.image) {
                    this.image.adoptController(this.controller);
                    this.image.selectViewByCode(this.view);

                    this.selectedFrame = this.image.selectedFrame();
                } else {
                    this.mountController();
                }
            },
        },

        mounted() {
            // Resize the view when window size changes.
            this.resize();
            window.addEventListener('resize', this.resizeWindow);

            this.mountController();
        },

        beforeDestroy() {
            if (this.image) {
                this.image.destroy();

                this.image = null;
            }

            window.removeEventListener('resize', this.resizeWindow);
        },

        methods: {
            /**
             * Resize after window resize.
             */
            resizeWindow() {
                setTimeout(() => {
                    // Wait a bit after resizing to allow parent container to respond first.
                    // Waiting using a timer since we are not sure when Swiper will resize slides.
                    this.resize();
                }, 10);
            },

            /**
             * Resizes image slide.
             */
            resize() {
                if (!this.$refs.container) {
                    return;
                }

                if (this.image) {
                    this.image.resize();
                }
            },

            mountController() {
                if (this.image) {
                    this.image.off();
                    this.image.destroy();
                }
            },

            errored() {
                // eslint-disable-next-line
                console.log(`Failed to render: ${this.view}`);

                this.$emit('hide');
            },

            rendered(sizing) {
                if (sizing) {
                    this.renderedSizing = sizing;

                    this.$emit('rendered', sizing);
                }
            },
        },
    };
</script>
